import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
import { Fade, Slide } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { Line } from 'react-chartjs-2';
import { AppStyles } from '../../../styles/AppTheme';
import { CustomMessageDialogStyles } from '../../../styles/CustomStyles';
import { AppConfig } from '../../../AppConfig';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../../common/helpers/Helper';
import { UiHelper } from '../../../common/helpers/UiHelper';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class GraphDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorDialogOpen: false,
      selectedError: null
    };
    this.chartOptions = {
      cutoutPercentage: 70,
      responsive: true,
      legend: {
        display: true,
        position: 'right',
        margin: {
          top: 0,
          bottom: 0
        },
        labels: {
          boxWidth: 8,
          fontSize: 10,
        },
        onClick: function (e, legendItem) {
          e.preventDefault();
        }
      },
      layout: {
        autoPadding: false,
        padding: {
          bottom: 0,
          top: 0
        }
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            // tooltipItem.index is the slice index
            return data.labels[tooltipItem.index]; // shows only "POP(6788)" etc.
          }
        }
      },
      maintainAspectRatio: false
    };
  }

  onCloseModal() {
    this.props.onClosed()
  }

  handleErrorClick = (item) => {
    console.log('handleErrorClick', item)
    this.setState({
      selectedError: item,
      errorDialogOpen: true
    });
  };

  handleErrorDialogClose = () => {
    this.setState({
      errorDialogOpen: false,
      selectedError: null
    });
  };

  getError = () => {
    try {
      return this.state.selectedError ? JSON.stringify(this.state.selectedError.error, null, 2) : ''
    } catch (error) {
      return Helper.getString('malFormedError')
    }
  }

  renderErrInfo = () => {
    return (
      <Dialog
        open={this.state.errorDialogOpen}
        onClose={this.handleErrorDialogClose}
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader])}>
          <div className={css(Styles.errorTitle)}>
            {this.state.selectedError && `${this.state.selectedError.code} - Latest Error` || 'Error Details'}
          </div>
          <button
            className={css(Styles.modalCloseButton)}
            onClick={this.handleErrorDialogClose}
          >
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {this.getError()}
          </pre>
        </div>
      </Dialog>
    )
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen || false}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth || false}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.eachChartHolder2)}>
            <div className={css(Styles.chartOuterWrap2)} >
              <div className={css(Styles.chartBlock)} >
                <Line data={this.props.lineChartData} options={this.props.lineChartOptions} />
              </div>
            </div>
          </div>
          {this.props.doughnutChartData && this.props.doughnutChartData.length > 0 &&
            <Grid className={css(Styles.chartsContainer)} container spacing={2}>
              {this.props.doughnutChartData.map((x, index) => {
                if (!x.data.datasets[0].data || x.data.datasets[0].data.length === 0) return ''
                return (
                  <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                    <div className={css(Styles.chartOuterWrap)} >
                      <div className={css(Styles.chartBlock)} >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          {x.chartTitle &&
                            <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                          }
                          {x.latestError[x.chartTitle] &&
                            <ErrorIcon
                              key={index}
                              style={{ fontSize: 24, cursor: 'pointer', color: 'red' }}
                              onClick={() => this.handleErrorClick(x.latestError[x.chartTitle])}
                            />
                          }
                        </div>
                        {x.hasDataMoreThanZero === false ?
                          <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                          <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                      </div>
                    </div>
                  </Grid>
                )
              })}
            </Grid>
          }
        </div>
        {this.state.errorDialogOpen && this.renderErrInfo()}
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#121212',
    fontSize: 28,
    '@media (max-width: 1024px)': {
      fontSize: 22,
      maxWidth: '70vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  errorTitle: {
    color: 'red',
    fontSize: 24,
    textAlign: 'left',
    paddingRight: 80,
  },
  modalContent: {
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: 16,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  container: {
    width: '100%',
    position: 'relative'
  },
  chartOuterWrap: {
    background: '#f5f5f5',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  eachChartHolder: {
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/charts/GraphDialog.js